import axios, { AxiosInstance } from "axios";
import { UploadFile, UploadOptions, UploadSingleResponse } from "./types";

const MEDIA_BASE_URL = "https://media.eatsy.vn";
const MEDIA_API_KEY = "admin_key_123456789";

class UploadService {
  private instance: AxiosInstance;

  constructor() {
    this.instance = axios.create({
      baseURL: MEDIA_BASE_URL,
      headers: {
        Accept: "application/json",
      },
      timeout: 30_000,
    });
  }

  async uploadSingle(
    file: UploadFile,
    options?: UploadOptions
  ): Promise<UploadSingleResponse> {
    const formData = new FormData();

    // Handle both web File object and React Native file object
    let filePart: any;

    if (file.uri instanceof File) {
      // Web environment - file.uri is a File object
      filePart = file.uri;
    } else {
      // React Native environment
      filePart = {
        name: file.name ?? "upload.jpg",
        type: file.type ?? "image/jpeg",
        uri: file.uri,
      };
    }

    formData.append("file", filePart);
    formData.append("folder", options?.folder ?? "barcode");

    const response = await this.instance.post<UploadSingleResponse>(
      "/upload/single",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-API-Key": MEDIA_API_KEY,
        },
      }
    );

    return response.data;
  }

  // Thêm method để upload multiple files nếu cần
  async uploadMultiple(
    files: UploadFile[],
    options?: UploadOptions
  ): Promise<UploadSingleResponse[]> {
    const uploadPromises = files.map((file) =>
      this.uploadSingle(file, options)
    );
    return Promise.all(uploadPromises);
  }

  // Method để validate file trước khi upload
  validateFile(file: UploadFile): { isValid: boolean; error?: string } {
    if (!file.uri) {
      return { isValid: false, error: "File URI is required" };
    }

    // Kiểm tra kích thước file (ví dụ: max 10MB)
    // const maxSize = 10 * 1024 * 1024; // 10MB
    // if (file.size && file.size > maxSize) {
    //   return { isValid: false, error: 'File size exceeds 10MB limit' };
    // }

    // Kiểm tra loại file
    const allowedTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"];
    if (file.type && !allowedTypes.includes(file.type)) {
      return { isValid: false, error: "File type not supported" };
    }

    return { isValid: true };
  }
}

export const uploadService = new UploadService();
